import { render, staticRenderFns } from "./ChildCategories.vue?vue&type=template&id=5e231402&scoped=true&"
import script from "./ChildCategories.vue?vue&type=script&lang=js&"
export * from "./ChildCategories.vue?vue&type=script&lang=js&"
import style0 from "./ChildCategories.vue?vue&type=style&index=0&id=5e231402&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e231402",
  null
  
)

export default component.exports